<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="120px" :rules="rules">
      <el-form-item label="报警代码" prop="warning_code">
        <el-input v-model="ruleForm.warning_code" />
      </el-form-item>
      <el-form-item label="报警类型" prop="warning_type">
        <el-select v-model="ruleForm.warning_type">
          <el-option
            v-for="item in SoftWareList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报警名称" prop="warning_name">
        <el-input v-model="ruleForm.warning_name" :maxlength="16" show-word-limit />
      </el-form-item>
      <el-form-item label="报警级别" prop="warning_level">
        <el-select v-model="ruleForm.warning_level">
          <el-option
            v-for="item in WarnLevelList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'

export default {
  name: '',
  data () {
    return {
      service: 'device_warning_setting',
      SoftWareList: BasicDataHelper.SoftWareList,
      WarnLevelList: BasicDataHelper.WarnLevelList,
      ruleForm: {
        warning_code: '',
        warning_type: '',
        warning_name: '',
        warning_level: ''
      },
      rules: {
        warning_code: [
          { required: true, message: '请输入报警代码', trigger: 'blur' }
        ],
        warning_type: [
          { required: true, message: '请选择报警类型', trigger: 'change' }
        ],
        warning_name: [
          { required: true, message: '请输入报警名称', trigger: 'blur' }
        ],
        warning_level: [
          { required: true, message: '请选择报警级别', trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Backend.insertRow(this, this.ruleForm)
        }
      })
    }
  }
}
</script>
